import { useNeedsIDCheck } from "@/hooks/useNeedsIDCheck";

import { KYCWarning } from "./KYCWarning/KYCWarning";

export const UserWarning = () => {
  const isIDCheck = useNeedsIDCheck();
  if (isIDCheck) return <KYCWarning />;

  return null;
};
